import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { SnackbarService, StageService } from '@saniup-webapps/shared'

/**
 * Sperrt die Anlage-Routen auf `env-production`. Auf der Produktivumgebung entstehen
 * Kassenverträge (und damit auch ihre Kriterien) ausschliesslich durch **Hochladen** eines
 * ZIP-Exports, der auf der Test- oder Demo-Umgebung angelegt und durchgetestet wurde.
 *
 * Backstop für Lesezeichen und offene Tabs — die Einstiege sind auf PROD ohnehin ausgeblendet.
 * Das Backend lehnt dieselben Aufrufe mit 403 ab (`ContractCreationStageGuard`).
 */
export function anlageNurAufTestumgebungGuard(redirectTo: string, hinweis: string): CanActivateFn {
  return () => {
    if (!inject(StageService).isProd()) {
      return true
    }
    inject(SnackbarService).showWarning(hinweis)
    return inject(Router).createUrlTree([redirectTo])
  }
}

export const VERTRAG_ANLAGE_GESPERRT_HINWEIS =
  'Verträge werden auf der Produktivumgebung nicht angelegt, sondern hochgeladen — anlegen und testen auf der Test- oder Demo-Umgebung.'

export const KRITERIUM_ANLAGE_GESPERRT_HINWEIS =
  'Kriterien werden auf der Produktivumgebung nicht angelegt — sie entstehen automatisch beim Hochladen eines Vertrags.'
